import React from "react";
import {
  VotingCardContainer,
  VotingCard as Card,
  Badge,
  LoadingSpinnerContainer,
  LoadingSpinner,
} from "../styles/Game.styles";

export default function VotingCard({
  team,
  selected,
  onClick,
  disabled = false,
  loading = false,
  children,
  badgeCount,
  ...rest
}) {
  const [internalLoading, setInternalLoading] = React.useState(false);
  const isLoading = loading || internalLoading;
  const isDisabled = disabled || isLoading;
  const showBadge = typeof badgeCount === "number" && badgeCount > 0;

  const handleClick = async (e) => {
    if (!onClick || isDisabled) return;
    const maybePromise = onClick(e);
    if (maybePromise && typeof maybePromise.then === "function") {
      try {
        setInternalLoading(true);
        await maybePromise;
      } finally {
        setInternalLoading(false);
      }
    }
  };

  return (
    <VotingCardContainer>
      {showBadge && <Badge>{badgeCount}</Badge>}
      <Card
        role="button"
        tabIndex={isDisabled ? -1 : 0}
        aria-busy={!!isLoading}
        aria-pressed={!!selected}
        aria-disabled={isDisabled}
        selected={selected}
        disabled={isDisabled}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (isDisabled) return;
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClick(e);
          }
        }}
        {...rest}
      >
        <span style={{ opacity: isLoading ? 0.6 : 1 }}>{children}</span>
        {isLoading ? (
          <LoadingSpinnerContainer>
            <LoadingSpinner />
          </LoadingSpinnerContainer>
        ) : null}
      </Card>
    </VotingCardContainer>
  );
}
